import styled from 'styled-components'

const VvsGotchiLogo = styled.div`
  background-image: url('/images/vvsGotchi/vvsgotchi_logo.png');
  background-size: contain;
  background-repeat: no-repeat;
  width: 100%;
  aspect-ratio: 9.545625;
  ${({ theme }) => theme.mediaQueries.sm} {
    pointer-events: none;
    background-image: url('/images/vvsGotchi/vvsgotchi_logo_lg.svg');
    aspect-ratio: 4.074626865671642;
    transform-origin: left top;
    transform: scale(1.8);
  }
  ${({ theme }) => theme.mediaQueries.md} {
    pointer-events: auto;
  }
`

export default VvsGotchiLogo
